import { Flowremind1 } from "../../../../src/components/images/support/workflows/Flowremind1.generated";
import { Flowremind2 } from "../../../../src/components/images/support/workflows/Flowremind2.generated";
import { Flowremind3 } from "../../../../src/components/images/support/workflows/Flowremind3.generated";
import * as React from 'react';
export default {
  Flowremind1,
  Flowremind2,
  Flowremind3,
  React
};